module.exports = __webpack_public_path__ + "img/163_thumbnail.7cbddaa4.jpg";